import { render, staticRenderFns } from "./ProductListComponent.vue?vue&type=template&id=674d5074&scoped=true"
import script from "./ProductListComponent.vue?vue&type=script&lang=js"
export * from "./ProductListComponent.vue?vue&type=script&lang=js"
import style0 from "./ProductListComponent.vue?vue&type=style&index=0&id=674d5074&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674d5074",
  null
  
)

export default component.exports